import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './POSTAUCT_Acquisition_Closing.css';

const POSTAUCT_Acquisition_Closing = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"POSTAUCT_ACQUISITION_CLOSING",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	POSTAUCT_ACQUISITION_CLOSING:-1
  });


  const [POSTAUCT_ACQUISITION_CLOSING, setPOSTAUCT_ACQUISITION_CLOSING] = React.useState(null);
  const [POSTAUCT_ACQUISITION_CLOSING_D, setPOSTAUCT_ACQUISITION_CLOSING_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Post-Auction Acquisition Closing');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPOSTAUCT_ACQUISITION_CLOSING(clientInfo,"OpenNew");

		navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPOSTAUCT_ACQUISITION_CLOSING(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPOSTAUCT_ACQUISITION_CLOSING(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPOSTAUCT_ACQUISITION_CLOSING(clientInfo,"OpenNew");
		}
		navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
		if(Temp_Data2.status!="New"){
			handleDeletePOSTAUCT_ACQUISITION_CLOSING(Temp_Data2);
			navigate('/POSTAUCT_Acquisition_Closing#New',{replace:true});
		} 
		else 
			navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Acquisition_Closing',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!POSTAUCT_ACQUISITION_CLOSING) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_${i}_SECTION`;
	  const headerId = `#POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [POSTAUCT_ACQUISITION_CLOSING]) ;


  
  
  var Ids = [];
  for(var Ele in POSTAUCT_ACQUISITION_CLOSING){
	  for(var Sec in POSTAUCT_ACQUISITION_CLOSING[Ele]){
		if(Sec == "id")
			Ids.push(POSTAUCT_ACQUISITION_CLOSING[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(POSTAUCT_ACQUISITION_CLOSING[Ele]["status"]);
		else if(Array.isArray(POSTAUCT_ACQUISITION_CLOSING[Ele][Sec]))
			  for(var Row in POSTAUCT_ACQUISITION_CLOSING[Ele][Sec])  // Convert to POSTAUCT_ACQUISITION_CLOSING[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in POSTAUCT_ACQUISITION_CLOSING[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["POSTAUCT_ACQUISITION_CLOSING"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPOSTAUCT_ACQUISITION_CLOSING(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_ACQUISITION_CLOSING`).then((response1) => {
		if(!POSTAUCT_ACQUISITION_CLOSING) 
			setPOSTAUCT_ACQUISITION_CLOSING(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_ACQUISITION_CLOSING_D`).then((response2) => {
			setPOSTAUCT_ACQUISITION_CLOSING_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPOSTAUCT_ACQUISITION_CLOSING_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPOSTAUCT_ACQUISITION_CLOSING = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_ACQUISITION_CLOSING/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPOSTAUCT_ACQUISITION_CLOSING(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPOSTAUCT_ACQUISITION_CLOSING = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_ACQUISITION_CLOSING/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPOSTAUCT_ACQUISITION_CLOSING = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_ACQUISITION_CLOSING/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPOSTAUCT_ACQUISITION_CLOSING = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_ACQUISITION_CLOSING', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePOSTAUCT_ACQUISITION_CLOSING = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_ACQUISITION_CLOSING', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["3"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0"]=value;
	Form_Data_onChange("3","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0",value,Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
  }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["3"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1"]=value;
	Form_Data_onChange("3","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1",value,Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
  }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["4"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("4","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["4"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_1"]=value;
	Form_Data_onChange("4","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_4"]=value;
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_0"]=value;
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4"]=value;
	//handleAddPOSTAUCT_ACQUISITION_CLOSING(Temp_Data,App_Data['POSTAUCT_ACQUISITION_CLOSING']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
    setPOSTAUCT_ACQUISITION_CLOSING(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!POSTAUCT_ACQUISITION_CLOSING) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPOSTAUCT_ACQUISITION_CLOSING =JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
  updatedPOSTAUCT_ACQUISITION_CLOSING[Sec] = [...updatedPOSTAUCT_ACQUISITION_CLOSING[Sec], newRow];
  setPOSTAUCT_ACQUISITION_CLOSING(updatedPOSTAUCT_ACQUISITION_CLOSING);
};

const handleDeleteRow = (sec,index) => {
  const updatedPOSTAUCT_ACQUISITION_CLOSING = JSON.parse(JSON.stringify(POSTAUCT_ACQUISITION_CLOSING));
  updatedPOSTAUCT_ACQUISITION_CLOSING[sec].splice(index, 1);
  setPOSTAUCT_ACQUISITION_CLOSING(updatedPOSTAUCT_ACQUISITION_CLOSING);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Post-Auction Acquisition Closing`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Post-Auction Acquisition Closing ID`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Acquisition Closing ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0" type="text" className="form-control" placeholder="POSTAUCT Acquisition Closing ID" value={POSTAUCT_ACQUISITION_CLOSING["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Acquisition Closing ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Result Intake ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1" type="text" className="form-control" placeholder="POSTAUCT Result Intake ID" value={POSTAUCT_ACQUISITION_CLOSING["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Result Intake ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2" type="text" className="form-control" placeholder="Asset ID" value={POSTAUCT_ACQUISITION_CLOSING["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SPV ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3" type="text" className="form-control" placeholder="SPV ID" value={POSTAUCT_ACQUISITION_CLOSING["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SPV ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Winning Bid USD`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Winning Bid USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0" type="text" className="form-control" placeholder="Winning Bid USD" value={POSTAUCT_ACQUISITION_CLOSING["2"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Winning Bid USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Closing Costs USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1" type="text" className="form-control" placeholder="Closing Costs USD" value={POSTAUCT_ACQUISITION_CLOSING["2"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Closing Costs USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Total Acquisition Cost USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2" type="text" className="form-control" placeholder="Total Acquisition Cost USD" value={POSTAUCT_ACQUISITION_CLOSING["2"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Total Acquisition Cost USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Acquisition Date`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Acquisition Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0" type="date"  value={POSTAUCT_ACQUISITION_CLOSING["3"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0`]} 
							onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0_Change} style={{ borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Acquisition Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Closing Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1" type="date"  value={POSTAUCT_ACQUISITION_CLOSING["3"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1`]} 
							onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1_Change} style={{ borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_3_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Closing Date
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Closing Statement Link`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Closing Statement Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0" type="text" className="form-control" placeholder="Closing Statement Link" value={POSTAUCT_ACQUISITION_CLOSING["4"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Closing Statement Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Closing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_1"  value={POSTAUCT_ACQUISITION_CLOSING["4"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_1`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_4_1_Change} className="form-control" name="Closing Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Closed">Closed</option>
						  <option value="Failed">Failed</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Closing Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0" type="text" className="form-control" placeholder="Submitted By" value={POSTAUCT_ACQUISITION_CLOSING["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1" type="text" className="form-control" placeholder="Submitted At" value={POSTAUCT_ACQUISITION_CLOSING["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2" type="text" className="form-control" placeholder="Reviewed By" value={POSTAUCT_ACQUISITION_CLOSING["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3" type="text" className="form-control" placeholder="Reviewed At" value={POSTAUCT_ACQUISITION_CLOSING["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_4"  value={POSTAUCT_ACQUISITION_CLOSING["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_4`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5" type="text" className="form-control" placeholder="Approval Notes" value={POSTAUCT_ACQUISITION_CLOSING["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_0"  value={POSTAUCT_ACQUISITION_CLOSING["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_0`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1" type="text" className="form-control" placeholder="Created By" value={POSTAUCT_ACQUISITION_CLOSING["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2" type="text" className="form-control" placeholder="Created At" value={POSTAUCT_ACQUISITION_CLOSING["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3" type="text" className="form-control" placeholder="Updated By" value={POSTAUCT_ACQUISITION_CLOSING["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4" type="text" className="form-control" placeholder="Updated At" value={POSTAUCT_ACQUISITION_CLOSING["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_ACQUISITION_CLOSING_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default POSTAUCT_Acquisition_Closing;  